<template>
    <feed-back
        v-if="feedBackShow"
        :env="env"
        :lang="lang"
        :internationalClassify="internationalClassify"
        :user-info="userInfo"
        :component-bottom="componentBottom"
        ref="feedbackRef"
        :tabs="tabs"
        :whetherTheCoexistence="whetherTheCoexistence"
        :theme-color="themeColor"
        :tabs-background-color="tabsBackgroundColor"
        :unfold-color="unfoldColor"
        :config-info="configInfo"
        :is-screenshots="isScreenshots"
        :help-info="helpInfo"
        :intimeevaluateUserInfo="intimeevaluateUserInfo"
        :intimeevaluateTempleteInfo="intimeevaluateTempleteInfo"
    />
</template>
<script>
import FeedBack from 'itsm-feedback-v2';
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
    components: {
        FeedBack,
    },
    computed: {
        ...mapGetters(['user', 'isNewVersion']),
        lang() {
            return this.$i18n.locale === 'zh-CN' ? 'zh-CN' : 'en-US';
        },
    },
    data() {
        const setEnv = {
            development: 'uat',
            production: 'prod',
            sit: 'uat',
            uat: 'uat',
            ver: 'uat',
        };
        return {
            feedBackShow: false,
            env: setEnv[process.env.NODE_ENV],
            tabs: [
                {
                    unique: 'G5000',
                    name: 'G5000',
                    nameEn: 'G5000',
                    nameJa: 'G5000',
                    icon: 'feedback-old-tool-filled',
                    iconColor: '#0077ff',
                    fontColor: '#666',
                },
                // {
                //     unique: 'advice',
                //     name: '我要建议',
                //     icon: 'feedback-edit-filledbeifen',
                //     jumpUrl: '',
                // },
                // {
                //     unique: 'help',
                //     name: '帮助中心',
                //     nameEn: 'Help center',
                //     nameJa: 'ヘルプセンター',
                //     icon: 'feedback-question',
                //     jumpUrl: '//guide.midea.com/helpCenter/?origin=GSC',
                // },
            ],
            // classify: {
            //     oneClassifyCode: 'yyyw',
            //     twoClassifyCode: 'yyyw_a17',
            //     threeClassifyCode: 'yyyw_a17_gsc',
            // },
            internationalClassify: {
                oneClassifyCode: 'hwgyl',
                twoClassifyCode: 'hwgyl_gsc',
                threeClassifyCode: 'hwgyl_gsc_gsc',
            },
            userInfo: {
                appId: process.env.NODE_ENV === 'production' ? '17547fc5dc444a889cb6d28e51808d34' : 'c813cc5cc16f40f69bab9262cd8eafde',
                token: '',
                user: this.$store.state.user.loginName,
                productId: 'ff7ce1ec-9340-424a-b55b-658527bce39b',   // 填写自己项目的产品id
                systemId: '37bc0efd-a018-4197-a267-046630621d55',    // 填写自己项目的系统id
                // productName:'UOP用户运营产品',                        //填写自己项目的产品的中文
                // systemName:'F-ITSM-C',                               // 填写自己项目的系统的中文
                commonFieldList: [
                    {
                        name: '角色',
                        value: '海外用户',
                    },
                    {
                        name: '菜单',
                        value: this.$route.meta.title,
                    },
                    {
                        name: '页面',
                        value: location.href,
                    },
                ],
            },
            intimeevaluateUserInfo: {
                user_name: this.$store.state.user.name, // mip账号（姓名）
                user_id: this.$store.state.user.loginName, // mip账号
            },
            intimeevaluateTempleteInfo: {
                appType: 'pc', // 终端类型 pc、app
                modeType: 'hover', // 弹框挂件展示类型 hover: 挂件式(悬浮右下角) inner:嵌入  默认:''不展示任何挂件
                business: '供应链领域', // 领域 eg: 内销领域
                system: 'G-GSC', // 系统 eg: 美云销
                product: 'SRM 供应商关系管理系统', // 产品 eg: TPC交易与履约中心
                scene: 'GSC-工作台', // 投放位置, 挂件式一般放页面右下角，eg: 人才搜索右侧
                primaryColor: '', // 提交按钮的主色调,默认：#0888ff
                hoverBtnColor: '', // 提交按钮在hover时候的颜色， 默认：#39a0ff
                hoverTagColor: '', // tag标签在hover时候的颜色 默认：#ebf5ff
            },
            componentBottom: 100, // 调整组件底部距离，(有默认值可以不传)
            whetherTheCoexistence: true, // 我要建议与我要评价是否共存
            themeColor: '#0077ff', // 主题颜色
            tabsBackgroundColor: '#fff', // tabs背景色
            unfoldColor: '#0077ff', // 展开按钮颜色
            configInfo: {
                mode: 2, // 1:GPM系统,2:GSC系统,3:CSS系统,不传和为空都是默认模式
                unfoldIcon: 'feedback-edit-filled',
                version: 1,
                channelCode: 'GSCsystem',
                // isDrag:true,//是否拖拽
                // justHangTabs:false,//是否只挂载tabs
                defaultUnrollOrFold: true, // 默认展开或收起，false为默认收起
                isLoginInterface: true,
                isMobile: true,
            },
            isScreenshots: true, //控制截图功能
            helpInfo: {
                systemName: 'GSC',
                relateId: '',
            },
        };
    },
    methods: {
        tmsGetToken(user) {
            axios.post('/gscapp/itsm/getToken', {
                user,
                auth_source: '4a',
            })
                .then((res) => {
                    const { tokenId } = res.data?.data?.datas;
                    if (tokenId) {
                        this.userInfo.token = tokenId;
                        this.feedBackShow = true;
                    }
                });
        },
        updateBtn() {
            this.tabs = this.tabs.filter((item) => item.unique !== 'switch');
            this.tabs.unshift(
                {
                    unique: 'switch',
                    name: this.isNewVersion ? this.$t('newHome.t3') : this.$t('newHome.t4'),
                    icon: this.isNewVersion ? 'feedback-switchover-old' : 'feedback-switchover-new',
                    fn: this.switchSystem,
                },
            );
        },
        switchSystem() {
            this.$store.commit('SET_NEW_VERSION', !this.isNewVersion);
            this.updateBtn();
        },
    },
    mounted() {
        this.tmsGetToken(this.user.loginName);
        this.updateBtn();
    },
};
</script>
